module.exports = __webpack_public_path__ + "img/21_104.92e12e4a.png";